import { render, staticRenderFns } from "./gl-badge-info.vue?vue&type=template&id=4250ceac"
import script from "./gl-badge-info.vue?vue&type=script&lang=js"
export * from "./gl-badge-info.vue?vue&type=script&lang=js"
import style0 from "./gl-badge-info.vue?vue&type=style&index=0&id=4250ceac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports